
  import { defineComponent } from 'vue';
  import { Box } from '@/ui/components/Box';
  import { PageSubtitle } from '@/ui/components/PageSubtitle';

  export default defineComponent({
    name: 'BillingFrequency',
    components: { PageSubtitle, Box },
    setup() {
      const csEmail = process.env.VUE_APP_CS_EMAIL;

      return {
        csEmail,
      };
    },
  });
